import React from 'react';

import Tippy from '@tippyjs/react';

import { Text } from '@components/common/Text';
import { JoinCallButton } from '@components/shared/JoinCallButton';
import { useUser } from '@hooks/useUser';

import { eventUrl } from '../../helpers';

import { CreateZoomButton } from './CreateZoomButton';

interface Props {
  participation: Participation;
  session: RepoSession;
}

export const EventUrl: React.FC<React.PropsWithChildren<Props>> = ({ participation, session }) => {
  const user = useUser();
  const url = eventUrl(participation);

  const inFuture = !participation.interview_at || participation.interview_at > new Date();
  const isZoom = participation.study?.video_url_type === 'zoom';
  const wasBooked =
    ['booked', 'completed', 'canceled', 'no_show'].includes(participation.status) &&
    participation.event_details?.start_time;

  if (!url && inFuture && isZoom && wasBooked) {
    return <CreateZoomButton sessionUuid={session.uuid} participationId={participation.id} />;
  }

  if (!url) return null;

  return (
    <Tippy arrow={false} content={'Join moderator call'}>
      <span>
        <JoinCallButton
          location='interview_room'
          medium
          small={false}
          noStyle
          href={url}
          currentUser={user}
          study={session.study}
          className='cursor-pointer whitespace-nowrap text-gray-600 hover:text-indigo-500'
        >
          <Text className='max-w-40' truncate>
            {url}
          </Text>
        </JoinCallButton>
      </span>
    </Tippy>
  );
};
